import { LegalPage } from "@/components/LegalPage";

const sections = [
  {
    label: "Information We Collect",
    paragraphs: [
      "We collect the following information to provide and improve our services: name, email, and payment information at checkout. Payments are processed by Stripe — we never store full card numbers on our servers.",
    ],
  },
  {
    label: "How We Use Data",
    paragraphs: [
      "Your email is used to deliver order confirmations and download links. We may also use your email to send occasional product updates and important account information.",
    ],
  },
  {
    label: "Sharing & Processing",
    paragraphs: [
      "We do not sell your personal data. Payment processing is handled by Stripe; their services and policies apply to card handling. We may share minimal order details with third-party service providers strictly to fulfil your purchase (e.g., payment processors, email delivery services).",
    ],
  },
  {
    label: "Cookies",
    paragraphs: [
      "We use cookies for basic site function, session management, and analytics. You may disable cookies in your browser, but some features may not work properly.",
    ],
  },
  {
    label: "Your Rights",
    paragraphs: [
      "Contact sales@benzthebrand.com for any data access, correction, or deletion requests.",
    ],
  },
];

export default function Privacy() {
  return <LegalPage title="Privacy Policy" updated="2026-07-06" sections={sections} testId="privacy-page" />;
}
